import React from 'react'
import { MenuItem, Typography } from '@material-ui/core'
import { SelectFormsy } from '@fuse'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

export default (props) => {
  const { label, name, value, formFields, setFormFields } = props
  const { formatMessage } = useIntl()
  const nationalityList = useSelector(
    ({ nationalities }) => nationalities.nationalityList,
  )
  return (
    <SelectFormsy
      className="w-full"
      name={name}
      label={formatMessage({ id: label })}
      value={value}
      variant="standard"
    >
      {nationalityList.length
        ? nationalityList.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.nationality}
                onClick={() => {
                  setFormFields({
                    ...formFields,
                    nationality: item.nationality,
                  })
                }}
              >
                <Typography>
                  {`${item.nationality} (${item.countryCode})`}
                </Typography>
              </MenuItem>
            )
          })
        : null}
    </SelectFormsy>
  )
}
